<!-- StorageDrawer.vue -->
<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <!-- 存储概况 -->
    <a-row v-if="storageSummary" style="margin-bottom: 16px;">
      <a-col :span="24">
        <a-alert
          type="info"
          show-icon
          :message="`本单位存储概况（ID：${form.tenantId || '—'}）`"
          :description="
            `总容量：${storageSummary.total} GB
已用：${storageSummary.used} GB
剩余：${storageSummary.free} GB`"
        />
      </a-col>
    </a-row>

    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>

    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />

    <a-form-model ref="form" :model="form" :rules="rules">
      <a-row :gutter="16">
        <!-- 到期时间 -->
        <a-col :span="24">
          <a-form-model-item label="到期时间" prop="expireTime" required>
            <a-date-picker
              v-model="form.expireTime"
              show-time
              format="YYYY-MM-DD HH:mm:ss"
              placeholder="请选择到期时间"
              style="width: 100%"
            />
          </a-form-model-item>
        </a-col>

        <!-- 存储溢出类型 -->
        <a-col :span="24">
          <a-form-model-item label="存储溢出类型" prop="overflowType" required>
            <a-select v-model="form.overflowType" placeholder="请选择存储溢出类型">
              <a-select-option :value="0">不允许超出存储</a-select-option>
              <a-select-option :value="1">允许超出存储</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>

        <!-- 状态 -->
        <a-col :span="24">
          <a-form-model-item label="状态" prop="status" required>
            <a-radio-group v-model="form.status">
              <a-radio :value="1">有效</a-radio>
              <a-radio :value="0">禁用</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <!-- 分配容量 -->
        <a-col :span="24">
          <a-form-model-item label="分配容量(GB)" prop="totalCapacity" required>
            <a-input-number
              v-model="form.totalCapacity"
              :min="-1"
              :precision="2"
              placeholder="请输入分配容量，-1 表示无限"
              style="width: 100%"
            />
          </a-form-model-item>
        </a-col>

        <!-- 单位标识（选填） -->
        <a-col :span="24">
          <a-form-model-item label="单位标识" prop="tenantId">
            <a-input-number
              v-model="form.tenantId"
              :min="0"
              placeholder="请输入单位标识"
              style="width: 100%"
            />
          </a-form-model-item>
        </a-col>

        <!-- 备注（选填） -->
        <a-col :span="24">
          <a-form-model-item label="备注" prop="remark">
            <a-textarea
              v-model="form.remark"
              :rows="3"
              placeholder="请输入备注"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-drawer>
</template>

<script>
import moment from 'moment'

export default {
  name: 'StorageDrawer',
  data() {
    return {
      open: false,
      formTitle: '分配存储空间',
      showLoading: false,
      storageSummary: null, // { total, used, free }

      form: {
        expireTime: null,
        overflowType: undefined,
        status: 1,
        totalCapacity: undefined,
        tenantId: undefined,
        remark: '',
      },
      rules: {
        expireTime: [
          { required: true, message: '请选择到期时间', trigger: 'change' },
        ],
        overflowType: [
          { required: true, message: '请选择存储溢出类型', trigger: 'change' },
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' },
        ],
        totalCapacity: [
          { required: true, message: '请输入分配容量', trigger: 'blur' },
          { type: 'number', message: '必须为数字' },
        ],
      },
    }
  },
  methods: {
    /* 供父组件调用：打开抽屉 */
    open(row = {}) {
      this.reset()
      Object.assign(this.form, row)
      this.open = true

      // 等 tenantId 回填后，再拉取概况
      this.$nextTick(() => this.loadStorageSummary(this.form.tenantId))
    },

    /* 关闭抽屉 */
    onClose() {
      this.open = false
    },

    /* 重置表单 */
    reset() {
      this.$refs.form && this.$refs.form.resetFields()
      this.storageSummary = null
    },

    /* 拉取存储概况 */
    async loadStorageSummary(tenantId) {
      if (!tenantId && tenantId !== 0) {
        this.storageSummary = null
        return
      }
      try {
        // 根据你的实际 axios 实例名修改
        const { data } = await this.$axios.get(`/api/storage/usage`, {
          params: { tenantId },
        })
        this.storageSummary = {
          total: data.totalCapacity,
          used: data.usedCapacity,
          free: data.totalCapacity - data.usedCapacity,
        }
      } catch (e) {
        this.$message.error('获取存储概况失败')
        this.storageSummary = null
      }
    },
  },
  watch: {
    /* tenantId 变化时实时刷新概况 */
    'form.tenantId'(val) {
      this.loadStorageSummary(val)
    },
  },
}
</script>

<style lang="scss" scoped></style>